export const AS_TOKEN = "AS_TOKEN";

export const AS_ADMIN_TOKEN = "AS_ADMIN_TOKEN";

export const AS_MANAGER_TOKEN = "AS_MANAGER_TOKEN";

export const SCHEDULE_CALL = "schedule_call";
export const CTR = "ctr_booster";
export const MAP_CHECKINS = "map_checkins";

export const LOCAL_URL = "http://localhost:3000";

export const GOOGLE_PLACE_API = "AIzaSyAl4tNd3X2ZgaOAqCdG5xys_jOJmJPW3b0";

export const GOOGLE_MAP_ID = "3abbfdddff7f5fb190de15c6";

export const GOOGLE_CLIENT_ID =
  "167382721507-o17nnd03mqihkv7fcn4fpgr3dd5mgo4u.apps.googleusercontent.com";
